import { render, staticRenderFns } from "./Register.vue?vue&type=template&id=5a343885&scoped=true&"
import script from "./register.js?vue&type=script&lang=js&"
export * from "./register.js?vue&type=script&lang=js&"
import style0 from "./Register.vue?vue&type=style&index=0&id=5a343885&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a343885",
  null
  
)

export default component.exports